import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '@/components/molecules/dialog';
import { useRemoveGDPRClause } from '@/features/settings/hooks/mutation/use-remove-gdpr-clause';

interface Props extends DialogActions {
  gdprClauseId: number;
}

const RemoveGdprClauseDialog = ({ open, onCancel, gdprClauseId }: Props) => {
  const { t } = useTranslation(['common', 'settings']);

  const { mutate, isPending } = useRemoveGDPRClause(onCancel);

  return (
    <Dialog
      title={t('common:areYouSure')}
      onCancel={onCancel}
      open={open}
      onConfirm={() => mutate(gdprClauseId)}
      variant="warning"
      isConfirmButtonDisabled={!gdprClauseId}
      isConfirmButtonSubmitting={isPending}>
      <Typography>{t('settings:gdpr.deleteConfirm')}</Typography>
    </Dialog>
  );
};

export default RemoveGdprClauseDialog;
